import React from 'react';

export const HomePage = () => {
  return (
    <div className="welcome"> 
      <h1>Welcome</h1>
      <h4>Click through the links above to learn about the Star Wars universe!</h4>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/HomePage/index.js